<template lang="pug">
  v-dialog(v-model="showPopup" persistent width="360")
    v-card.popup-nps
      v-card-text
        .close
          img(:src="imgClose" alt="Cerrar pop-up NPS" style="float:right" width="12px" @click="closePopup")
        .score-avatar.img-end
          img(:src="imgAvatar" alt="Personaje animado")
        p.omnesRegular.text-primary.g-text-center
          | Muchas gracias por tu calificación,
          br
          | esto nos ayudará a seguir mejorando.
        .button-container
          v-btn.omnesSemibold(@click="closePopup") Ok
</template>

<script>
export default {
  props: [
    'showPopup',
    'imgClose',
    'imgAvatar'
  ],
  methods: {
    closePopup () {
      this.$store.commit('nps/setPopupNpsFinal', false)
    }
  }
}
</script>

<style scope>
  .popup-nps .img-end img {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/nps/PopupNpsFinal.vue